import { Text } from 'slate';
import { isElement } from '../../../utilities/nodes/elements/isElement.mjs';

/**
 * Convert Slate Nodes into HTML string
 */
function serializeToHTML(
/**
 * Slate nodes to convert to HTML.
 */
nodes, {
  plugins
}) {
  const beforeSerialize = plugins.reduce((acc, plugin) => {
    var _plugin$serialize;
    return (_plugin$serialize = plugin.serialize) != null && _plugin$serialize.before ? [...acc, plugin.serialize.before] : acc;
  }, []);
  const result = nodes.map(entry => {
    const node = beforeSerialize.reduce((acc, fn) => {
      var _fn;
      return (_fn = fn(acc)) != null ? _fn : acc;
    }, entry);
    if (Text.isText(node)) {
      if (!node.text) {
        // Do not serialize empty leaves
        return '';
      }
      return serializeLeaf({
        plugins,
        leafProps: {
          leaf: node,
          text: node,
          children: node.text,
          attributes: {
            'data-slate-leaf': true
          }
        }
      });
    }
    return serializeNode({
      plugins,
      elementProps: {
        element: node,
        children: serializeToHTML(node.children, {
          plugins
        }),
        attributes: {
          'data-slate-node': 'element',
          ref: null
        }
      }
    });
  }).join('');
  return plugins.reduce((acc, plugin) => {
    var _plugin$serialize$aft, _plugin$serialize2, _plugin$serialize2$af;
    return (_plugin$serialize$aft = (_plugin$serialize2 = plugin.serialize) == null ? void 0 : (_plugin$serialize2$af = _plugin$serialize2.after) == null ? void 0 : _plugin$serialize2$af.call(_plugin$serialize2, acc)) != null ? _plugin$serialize$aft : acc;
  }, result);
}
function serializeNode({
  plugins,
  elementProps
}) {
  const {
    element
  } = elementProps;

  // If no type provided we return the children without wrapping
  if (!isElement(element)) {
    return elementProps.children;
  }
  let html;

  // Search for matching plugin based on element type
  plugins.some(plugin => {
    var _plugin$serialize3, _plugin$deserialize, _plugin$deserialize$e, _plugin$serialize$ele, _plugin$serialize4, _plugin$serialize4$el;
    if (!((_plugin$serialize3 = plugin.serialize) != null && _plugin$serialize3.element)) return false;
    if (plugin.deserialize && !((_plugin$deserialize = plugin.deserialize) != null && (_plugin$deserialize$e = _plugin$deserialize.element) != null && _plugin$deserialize$e.some(item => item.type === String(element.type)))) {
      html = elementProps.children;
      return false;
    }
    html = (_plugin$serialize$ele = (_plugin$serialize4 = plugin.serialize) == null ? void 0 : (_plugin$serialize4$el = _plugin$serialize4.element) == null ? void 0 : _plugin$serialize4$el.call(_plugin$serialize4, elementProps)) != null ? _plugin$serialize$ele : '';
    return true;
  });
  return html;
}
function serializeLeaf({
  plugins,
  leafProps
}) {
  const {
    children: text
  } = leafProps;
  return plugins.reduce((result, plugin) => {
    var _plugin$serialize5, _plugin$serialize6, _plugin$serialize6$le;
    if (!((_plugin$serialize5 = plugin.serialize) != null && _plugin$serialize5.leaf)) {
      return result;
    }
    const newLeafProps = {
      ...leafProps,
      children: result
    };
    const markup = (_plugin$serialize6 = plugin.serialize) == null ? void 0 : (_plugin$serialize6$le = _plugin$serialize6.leaf) == null ? void 0 : _plugin$serialize6$le.call(_plugin$serialize6, newLeafProps);
    if (markup === text) {
      return result;
    }
    const html = markup != null ? markup : '';
    return html;
  }, text);
}

export { serializeToHTML };
